module.exports = __webpack_public_path__ + "static/media/hemi_head_bd_it-webfont.ec1b14f5.svg";